import { useEffect, useState } from "react";

const useUserData = () => {
    const [userData, setUserData] = useState<any>(null);

    useEffect(() => {
        if (sessionStorage.getItem("userDetails")) {
            let user = JSON.parse(sessionStorage.getItem("userDetails") || "");
            setUserData(user);
        }
    }, [])

    return { userData }
}

export default useUserData